<template>
    <div class="coaching-section" v-if="coaching">
        <section-header title="Coaching Certification" icon="fa-whistle"/>

        <ui-card>
            <!-- Membership ID + sync state -->
            <div class="columns is-vcentered">
                <div class="column is-narrow">
                    <i class="fad fa-id-card fa-2x has-text-primary"></i>
                </div>
                <div class="column">
                    <template v-if="coaching.membership.number">
                        <div class="has-text-weight-bold">WIAA Membership ID {{ coaching.membership.number }}</div>
                        <div class="is-size-7 has-text-grey" v-if="coaching.membership.synced_at">
                            <i class="fas fa-rotate mr-1"></i>Synced with FinalForms {{ coaching.membership.synced_at | timeAgo }}
                        </div>
                        <div class="is-size-7 has-text-grey" v-else>
                            <i class="far fa-circle-info mr-1"></i>Not yet synced with FinalForms
                        </div>
                    </template>
                    <template v-else>
                        <div class="has-text-weight-bold">Add your WIAA Membership ID</div>
                        <div class="is-size-7 has-text-grey">FinalForms uses it to pull your certificates onto your coaching record.</div>
                    </template>
                </div>
                <div class="column is-narrow">
                    <b-button size="is-small" tag="router-link" :to="{name: 'account', params: {section: 'certs'}}">
                        <i class="far fa-pen mr-2"></i>{{ coaching.membership.number ? 'Manage' : 'Add ID' }}
                    </b-button>
                </div>
            </div>

            <!-- Certificates on file: one row each, newest first -->
            <div class="coaching-row" v-if="coaching.certificates.length">
                <div class="has-text-weight-bold mb-3">WIAA Certificates on File <span class="tag is-light ml-1">{{ coaching.certificates.length }}</span></div>
                <div class="cert-list">
                    <div class="cert-row" v-for="c in visibleCertificates" :key="c.cert_id">
                        <div class="cert-icon"><i class="fad fa-file-certificate has-text-primary"></i></div>
                        <div class="cert-title">{{ c.title }}</div>
                        <div class="cert-date">Awarded {{ c.awarded_at | dateOnly }}</div>
                    </div>
                </div>
                <div class="mt-3" v-if="coaching.certificates.length > visibleCertificates.length">
                    <router-link :to="{name: 'reports', params: {view: 'completed'}}" class="has-text-weight-bold">All Certificates ({{ coaching.certificates.length }}) <i class="fas fa-arrow-right ml-1"></i></router-link>
                </div>
            </div>
            <div class="coaching-row has-text-grey is-size-6" v-else>
                <i class="far fa-circle-info mr-2"></i>No WIAA certificates on file yet. Certificates appear here as you complete WIAA courses.
            </div>

            <template #footer>
                <div class="columns">
                    <div class="column is-size-7 has-text-grey">Rules clinics, coaching education and eligibility training for Washington interscholastic coaches.</div>
                    <div class="column has-text-right">
                        <b-button type="is-primary" size="is-small" tag="router-link" :to="{name: 'course-catalog'}"><i class="fas fa-search mr-2"></i>Browse WIAA Courses</b-button>
                    </div>
                </div>
            </template>
        </ui-card>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import UiCard from "../UiCard";
    import SectionHeader from "../framework/SectionHeader";

    // The coach's counterpart of the PD section: WIAA membership ID and
    // FinalForms sync, and the certificates on file. Rendered only while the
    // WIAA certification is switched on. The season's Coaches Update form is
    // deliberately NOT surfaced here (Derek 2026-09-15): an unfinished one
    // reaches the student through Needs Your Attention like any application.
    export default {
        name: "CoachingSection",
        components: {UiCard, SectionHeader},
        computed: {
            ...mapGetters({coaching: 'dashboardCoaching'}),
            // the newest six; the Certificates & Forms page has the full list
            visibleCertificates() {
                return this.coaching.certificates.slice(0, 6);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .coaching-row {
        border-top: 1px solid #e8eef4;
        margin-top: .75rem;
        padding-top: .75rem;
    }

    .cert-row {
        display: grid;
        grid-template-columns: 1.75rem minmax(0, 1fr) auto;
        gap: .75rem;
        align-items: start;
        padding: .55rem 0;
        border-bottom: 1px solid #e8eef4;
        font-size: .95rem;

        &:last-child {
            border-bottom: none;
        }
        .cert-icon {
            text-align: center;
            padding-top: .1rem;
        }
        .cert-title {
            font-weight: 600;
        }
        .cert-date {
            color: #7a8794;
            white-space: nowrap;
            font-variant-numeric: tabular-nums;
        }
    }
    @media (max-width: 600px) {
        .cert-row {
            grid-template-columns: 1.75rem minmax(0, 1fr);
            .cert-date { grid-column: 2; }
        }
    }
</style>
